module.exports = new __parcel__URL__("57x40.7c1f5807.webp").toString();